import React, { Component } from "react";
import Appbar from "./appbar";

export default class TNDC extends Component {
  render() {
    return (
      <div className="main-terms-conditions">
        <Appbar center={true} />
        <div className="scroll-term">
          <div className="inner-scroll">
            <ul className="terms-conditions">
              <div className="terms-condtions-title">
                Terms & Conditions for Distributor Initiated Transactions (DIT)
              </div>
              <li>
                The Distributor acknowledges that by using the facility offered
                through the Distributor Initiated Transactions (DIT); an online
                facility for the Distributor through the website of Mirae Asset
                Investment Managers (India) Pvt. Ltd. (AMC), it hereby agrees to
                abide by the below terms, conditions, rules and operating
                guidelines-
              </li>
              <li>
                The Fund, through its empanelled distributors will offer the
                facility of transacting on-line through Internet for the
                convenience of its unitholders and help them place/submit
                transaction in the Fund, by authorization of link generated for
                the said purpose (hereinafter referred to as "LINK");
              </li>
              <li>
                The Distributor has taken necessary authorization /consent from
                its Investors/Unitholder(s) of the fund and is desirous of
                availing the services/facilities available through the Website.
              </li>
              <li>
                For the purposes of this Agreement, Website shall mean
                www.miraeassetmf.co.in which AMC may announce from time to time.
                Designated Account / Master Account shall mean the Folio Number
                allotted to the Unitholder and hereinafter referred to as “Folio
                Number”. AMC reserves the right to change, amend or modify the
                fund's website as may be intimated from time to time.
              </li>
              <li>
                Usage of, or subscription to, the said “LINK” Facility shall be
                in addition to, and not in substitution of, the existing
                procedure for conducting the transactions, the services of which
                are available through the Online Transactions as well.
              </li>
              <li>
                The Fund shall not be responsible for any errors that may be
                committed by the Distributor for its Investors/Unitholder of the
                fund in the process of conducting any Online “LINK” or for any
                error or failure of the transaction over internet due to any
                network / technical problems.
              </li>
              <li>
                The Distributor understands and agrees that the NAV
                applicability for all purchase transactions which are equal to
                greater than 2 lacs, the NAV applicability will be based on the
                credit time of the funds received to the scheme collection
                account and not the time at which the Unitholders bank account
                was debited. Further, the AMC shall not be responsible for any
                loss of whatsoever nature, if the User encounters any technical
                snag due to slowness on the internet, expiry of the sessions OR
                due to other technical reasons either on the banks end or the
                website be it downtime, maintenance or declines.
              </li>
              <li>
                Further, the Distributor also understands that if the bank
                account has been debited and the transaction has not been
                received at the AMC end, it will not be considered as a valid
                transaction and the funds so received may be credited back to
                the bank account or shall be considered for such delayed receipt
                of the application.
              </li>
              <li>
                The Distributor agrees that pursuant to this Agreement of
                availing of the “LINK” facility, the Fund/its service provider
                will record the required transaction processing in the
                Unitholder's Folio, subject to standard validations as per
                normal procedure and as per the prevalent norms prescribed by
                the Fund /AMC or any regulatory authority. The User understands
                that the same will be entirely at the risk of the Unitholder
                itself.
              </li>
              <li>
                The Distributor agrees that it shall be the sole responsibility
                of the Distributor to ensure adequate protection,
                confidentiality and secrecy of the transaction and any
                disclosure thereof to any other person shall be entirely at the
                Distributor’s risk. AMC in such cases will not accept any kind
                of responsibility or liability for any loss, damage or harm.
              </li>
              <li>
                The Distributor also understands that AMC reserves the right to
                change the “LINK” issuance process. Further, the Distributor
                acknowledges that this being an online facility, relevant
                portions of the guidelines/necessary agreements of Online
                transactions will suo-motto apply for usage of / accessing the
                DIT site as well.
              </li>
            </ul>

            <ul className="terms-conditions-last">
              <div className="terms-condtions-title">AMC WARRANTIES</div>
              <li>
                AMC will take best efforts to keep the Website updated on a
                daily basis, so as to provide most current information to
                Distributor’s. The Distributor also agrees that the look and
                feel of the web screen and outputs there from may differ based
                on the nature of the browser/software used by the Distributor to
                browse the Website.
              </li>
              <li>
                AMC agrees to take best efforts to protect security of the data
                placed on the Internet and has for this purpose, required the
                service provider to sign a confidentiality agreement specifying
                confidentiality of the data and to restrict external access to
                the database on the Internet.
              </li>
              <li>
                AMC or the service provider shall have the absolute discretion
                to amend or supplement any of the terms at any time and will
                endeavor to give prior notice on the website / through email for
                such changes wherever feasible.
              </li>
              <li>
                The Fund / its service provider may, in its absolute discretion
                decide not to carry out any such transaction where the service
                provider or the Fund has reason to believe that the instructions
                are not genuine, are unclear, are such as to raise a doubt, are
                otherwise improper or there is ground to believe that the same
                is in contravention of any statute/laws in India and cannot be
                put into effect.
              </li>
            </ul>

            <ul className="Amc-terms">
              <div className="terms-condtions-title">
                I/We have also ensured/acknowledged that:
              </div>
              <li>
                The investors have read the Key Information Memorandum (KIM) and
                the terms of the Scheme Information Document (SID) and Statement
                of Additional Information (SAI) of the Schemes carefully before
                investing / filing the application form.
              </li>
              <li>
                The investors are aware of the prevailing Load Structure before
                making application for investments.
              </li>
              <li>
                The investors/applicants have read, understood and accepted the
                terms, subject to which the offers are being made and that they
                are aware that they bind themselves to the terms upon executing
                the transaction.
              </li>
              <li>
                NRI/FII investors must be provide overseas address (mandatory)
              </li>
              <li>
                In case of minor investor, name of the guardian must be
                mentioned if the investments are being made on behalf of a
                minor. Guardian of the minor must be either a natural guardian
                or a Court appointed guardian. Date of birth is mandatory for
                minors and has to be supported with Age proof.
              </li>
              <li>
                For FATCA and CRS compliance the AMC may seek additional
                personal, tax and beneﬁcial owner information and certain
                certiﬁcations and documentation from all the account holders and
                will report to tax authorities / appointed agencies/
                institutions such as withholding agents. Any change in any
                information provided shall be intimated to AMC promptly, i.e.,
                within 30 days.
              </li>
              <li>
                Investor will be informed that Aadhaar has become mandatory for
                investment in MF Industry effective 1st June'2017 and Aadhaar /
                proof of Aadhaar enrolment will be collected and authenticated
                for all individuals irrespective of mode of holding. In case if
                Aadhaar number has not been assigned to the investor, the proof
                of application for enrolment of Aadhaar shall be furnished and
                in case the PAN is not submitted, one certified copy of an
                officially valid document shall be submitted. If such individual
                investor is not eligible to be enrolled for Aadhaar number, he /
                she shall submit to the Reporting entity, PAN or Form no. 60. If
                the Investor does not submit the PAN, he/she shall submit one
                certified copy of officially valid document containing details
                of identity, address and a Photograph. If the investor fails to
                submit the Aadhaar number and PAN by 31st Dec 2017, his account
                shall cease to be operational till the time Aadhaar number and
                PAN is submitted by the Investor. Folios / Accounts where
                Aadhaar is not seeded by December 31, 2017, they shall be made
                inoperative. Once an account is made inoperative, transactions
                will be restricted. Investors may also be informed that if the
                Name given for transaction does not match the name as appearing
                on the PAN Card/Aadhaar card, , application may be liable to get
                rejected or further transactions may be liable to get rejected'.
              </li>
              <li>
                Every employee/relationship manager/sales person of the
                distributor/broker (interacting with the investor for the sale
                of Mutual Fund products) of mutual fund products will quote the
                EUIN (for non-advisory transactions ('execution only') &
                advisory transactions) obtained from AMFI in the CAF.
              </li>
              <li></li>
              <ul>
                <li>
                  New individual investors who have never done KYC under KRA
                  (KYC Registration Agency) regime and whose KYC is not
                  registered or verified in the KRA system will be required to
                  fill the new CKYC form while investing with the Fund.
                </li>
                <li>
                  In case the investor's PAN is not updated in CKYC system, a
                  self-certified copy of PAN Card shall be mandatory. Further,
                  the AMC/ Mutual Fund shall use the KIN of the investors to
                  download the KYC information from CKYC and update its records
                  as and when required. There is no impact on the Existing
                  Investors who have done the SEBI KYC (KYC thru 5 KRAs, CVL,
                  NDML, DOTEX, Kfintech & CAMS). They can continue to invest as
                  it is in any schemes of any Mutual Fund; Existing Investors
                  who wishes to onboard themselves on the CKYC platform will
                  need to again do the entire KYC process just like New Investor
                  and get the KIN which can be used across.
                </li>
              </ul>
              <li>
                In case of non-compliance of any C-KYC requirements,
                Applications shall liable to be rejected without any intimation
                to the applicants. Any Change in Address for all KYC compliant
                Investors has to be routed through KRA and that direct
                application to AMC will be not processed/rejected.
              </li>
              <li>
                The AMC will not be liable to the investor if the transaction is
                processed by the distributor but payment is not made by the
                investor.
              </li>
              <li>
                It shall be the sole responsibility of the distributor to ensure
                that the investor makes payments in a timely manner for
                applicable NAV.
              </li>
              <li>
                If the application is filled by the Distributor but the payment
                transaction has not been effected by the customer within the
                cut-off time, the investor will be allotted the applicable days
                NAV.
              </li>
              <li>
                If any switch transaction is being effected by the distributor,
                then the same has to be validated by the investor without which
                the same shall not get effected.
              </li>
              <li>
                In no case, the Sponsors/AMC/Trustee Co./Directors of Sponsors,
                AMC and Trustee Co./employees/its appointed service providers
                shall be held liable if the transaction does not get processed
                due to non-fulfilment of all the conditions and criteria’s as
                specified by the AMC.
              </li>
              <li>
                In case the investor files any suit/initiates legal action
                against the AMC for losses incurred by him due to the negligence
                on part of the Distributor in effecting the transaction, the
                Distributor shall be liable to indemnify the AMC of the
                compensation/damages which it shall have to pay to the investor
              </li>
              <li>
                The Distributor shall be liable to the AMC in case he commits
                any fraud or non-authorized transaction by the investor and
                shall be liable to all the legal actions which the AMC has at
                its discretion and remedy.
              </li>
              <li>
                It shall be the responsibility of the Distributor to ensure that
                he himself/his/her employees adhere to the AMFI Code of Conduct
                for Distributors and complies with all the
                rules/regulations/guidelines as specified by AMFI or any other
                self-regulated organization of distributors which they may be
                subject to in future.
              </li>
              <li>
                The Distributor ensures that the investor complies with all the
                requirements as specified by SEBI/AMFI from time to time.
              </li>
              <li>
                The Distributor ensures that the investor is updated about all
                the latest addendums/notice issued by the AMC and any other
                regulatory changes issued by SEBI, from time to time.
              </li>
              <li>
                The Distributor shall adhere to the current stance of the AMC on
                seeking investments from US person and Canada residents. The
                Distributor shall not solicit investments from US persons and
                residents of Canada.
              </li>
            </ul>
          </div>
        </div>
      </div>
    );
  }
}
